import { collection, where, query, getDocs, doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import { uid } from "uid";

export const getSneakPeekWithEmail = async (email: string) => {
    try {
        // Reference to the specific document in the "candidates" collection
        const sneakPeekRef = collection(db, `sneakPeek`);

        // Create the query for positions with status 'open'
        const q = query(sneakPeekRef, where('email', '==', email));

        // Execute the query and get the documents
        const sneakPeekListSnapshot = await getDocs(q);

        // Process the documents as needed, for example, converting them to a simple array of data
        const sneakPeek: any = sneakPeekListSnapshot.docs.map(doc => ({ idSneakPeek: doc.id, ...doc.data() }))
        if (sneakPeek.length > 0) {
            const sneakPeekData = sneakPeek[0] as { idSneakPeek: string, company: string, email: string, fullName: string, id: string, privacyAccepted: boolean, visitCounter: number }
            return sneakPeekData
        } else {
            return null
        }


    } catch (error) {
        console.error("Error fetching candidate: ", error);
        return null; // Handle the error appropriately
    }
}

export const setSneakPeekWithEmail = async (email: string, fullName: string, company: string, checkPrivacy: boolean) => {
    try {
        const idNewUser = uid(24)

        const sneakPeekDocRef = doc(db, 'sneakPeek', idNewUser);

        setDoc(sneakPeekDocRef, {
            email: email,
            fullName: fullName,
            company: company,
            visitCounter: 1,
            privacyAccepted: checkPrivacy,
            id: idNewUser
        });

        return true
    } catch (error) {
        return false;
    }
}

export const updateSneakPeekWithEmail = async (id: string, count: number) => {
    try {
        const sneakPeekDocRef = doc(db, 'sneakPeek', id);

        updateDoc(sneakPeekDocRef, { visitCounter: count + 1 });

        return true
    } catch (error) {
        return false;
    }
}